import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
  contractRoute,
  dashboardIndexRoute,
  dashboardRoute,
  employeePrintRoute,
  employeesRoute,
  employerRefRoute,
  ertnRoute,
  maintenanceRoute,
  ratesRoute,
  reportsRoute,
  schedulesRoute,
  userAgreementRoute,
  usersRoute,
  notificationsRoute,
  reconciliationRoute,
  retroPayRoute,
} from '@/root-app/app-routes/routes';
import RootApp from '@/root-app/RootApp';
import { ROUTE_NAMES } from '@/core/routes/routeNames';
import RoutingErrorPage from '@/components/Error/RoutingErrorPage';

const AppRoutes: RouteObject = {
  path: ROUTE_NAMES.ROOT,
  Component: RootApp,
  errorElement: <RoutingErrorPage />,
  children: [
    dashboardIndexRoute,
    maintenanceRoute,
    userAgreementRoute,
    dashboardRoute,
    schedulesRoute,
    employeesRoute,
    contractRoute,
    employerRefRoute,
    ertnRoute,
    usersRoute,
    reportsRoute,
    employeePrintRoute,
    ratesRoute,
    notificationsRoute,
    reconciliationRoute,
    retroPayRoute,
  ],
};

export default AppRoutes;
